import React from "react";
import { useI18n } from "../i18n";
import { useSeo } from "../hooks/useSeo";
import { pathFor } from "../config/site";
import { TIMELINE, IMAGES } from "../data/structure";
import { webpageLd, articleLd, breadcrumbLd, personLd } from "../lib/jsonld";
import PageHero from "../components/PageHero";
import { Section, SectionHeading } from "../components/Section";
import Timeline from "../components/Timeline";
import WorksHighlights from "../components/WorksHighlights";
import OfficialLinks from "../components/OfficialLinks";

export default function FilmPage({ pageKey }) {
  const { lang, d } = useI18n();
  const meta = d.meta.film;
  const items = TIMELINE.filter((t) => t.category === "film");

  useSeo({
    pageKey,
    title: meta.title,
    description: meta.description,
    jsonLd: [
      webpageLd({ lang, pageKey, title: meta.title, description: meta.description }),
      articleLd({ lang, pageKey, headline: d.pillars.film.title, description: meta.description }),
      personLd(),
      breadcrumbLd([
        { name: d.ui.nav.home, path: pathFor(lang, "home") },
        { name: d.ui.nav.film, path: pathFor(lang, "film") },
      ]),
    ],
  });

  return (
    <>
      <PageHero testid="film-hero" kicker={d.pillars.film.title} title={d.meta.film.title.split(" |")[0]} intro={d.pages.film.intro} image={IMAGES.redCarpet} />
      <WorksHighlights only="film" />
      <Section testid="film-timeline">
        <SectionHeading kicker={d.timelineSection.kicker} heading={d.worksSection.film} />
        <div className="mt-14"><Timeline items={items} /></div>
      </Section>
      <OfficialLinks />
    </>
  );
}
